"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSamplesLeadsProduct = exports.getSamplesLeadsProducts = exports.getSamplesLeadsProductById = exports.deleteSamplesLeadsProduct = exports.createSamplesLeadsProduct = exports.addBulkSamplesLeadsProducts = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
// import { ILeadsProductData } from './types'
// export const defaultLeadsProductData: ILeadsProductData = {
//   id: 0,
//   enabled: true,
//   leadId: null,
//   productId: null,
//   productsVariationId: null,
//   quantity: 1,
//   salePrice: 0,
//   unitPrice: 1,
//   subTotal: 0,
//   total: 0,
//   taxId: null,
//   taxAmount: 0,
//   taxRate: 0,
// }
const getSamplesLeadsProducts = params => (0, _request.default)({
  url: '/samples-leads-products',
  method: 'get',
  params
});
exports.getSamplesLeadsProducts = getSamplesLeadsProducts;
const getSamplesLeadsProductById = id => (0, _request.default)({
  url: `/samples-leads-products/${id}`,
  method: 'get'
});
exports.getSamplesLeadsProductById = getSamplesLeadsProductById;
const updateSamplesLeadsProduct = (id, data) => (0, _request.default)({
  url: `/samples-leads-products/${id}`,
  method: 'patch',
  data
});
exports.updateSamplesLeadsProduct = updateSamplesLeadsProduct;
const deleteSamplesLeadsProduct = id => (0, _request.default)({
  url: `/samples-leads-products/${id}`,
  method: 'delete'
});
exports.deleteSamplesLeadsProduct = deleteSamplesLeadsProduct;
const createSamplesLeadsProduct = data => (0, _request.default)({
  url: '/samples-leads-products/',
  method: 'post',
  data
});
exports.createSamplesLeadsProduct = createSamplesLeadsProduct;
const addBulkSamplesLeadsProducts = data => (0, _request.default)({
  url: '/samples-leads-products/bulk',
  method: 'post',
  data
});
exports.addBulkSamplesLeadsProducts = addBulkSamplesLeadsProducts;